@if (vm$ | async; as vm) {
  <ng-container *transloco="let t; read: 'revisions.detail'">
    <ng-container *transloco="let tGlobal">
      <h2 class="margin-bottom-medium">{{t('searchTitle')}}</h2>
      <form
        [formGroup]="filterForm"
        (ngSubmit)="onSubmit(vm.searchRequest)"
        class="searchForm">
        <kendo-formfield>
          <kendo-label [text]="t('revisionStatus')"></kendo-label>
          <kendo-dropdownlist
            [data]="serviceStatus"
            textField="text"
            valueField="value"
            formControlName="revisionStatus"
            [defaultItem]="{ value: null, text: t('chooseRevisionStatus') }"
            [valuePrimitive]="true">
          </kendo-dropdownlist>
        </kendo-formfield>
        <kendo-formfield>
          <div class="searchInputContainer">
            <span  class="tooltipContainer">
              <kendo-label [text]="t('keyword')"></kendo-label>
              <span [attr.tooltip]="t('tooltipSearchDevices')" flow="right" class="tooltipContainer">
                <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
              </span>
            </span>
            <kendo-textbox
              formControlName="keyword" class="searchTextField">
            </kendo-textbox>
          </div>
        </kendo-formfield>
        <div class="buttonContainer margin-bottom-large">
          <button
            [disabled]="filterForm.invalid || filterForm.pristine"
            type="submit"
            kendoButton
            class="buttonPrimary">
            {{t('filterSearch')}}
          </button>
          <button
            type="button"
            (click)="resetFilter()"
            class="buttonSecondary">
            {{ t('resetFilter') }}
          </button>
        </div>
      </form>
      <div class="chosenElements">
        @for (device of vm.devices; track device; let index = $index) {
          <!-- Device Element -->

          <div class="chosenElement">
            
            <!-- Device Info -->
            <div class="xs12col s6col flex-wrap">
              @if (device.manufacturer?.name) {
                <span><strong>{{device.manufacturer?.name}}</strong>&nbsp;|</span>
              }
              @if (device.deviceCategory?.name) {
                <span>&nbsp;{{device.deviceCategory?.name}}</span>
              }
              @if (device.deviceLocation?.name) {
                  <span>&nbsp;|&nbsp;{{ device.deviceLocation.name }}</span>
              }
              <table class="linkedDeviceTable xs12col">
                @if (device.serialNumber) {
                  <tr>
                    <td>
                      <strong>{{ t("device.serialNumber") }}</strong>
                    </td>
                    <td>{{ device.serialNumber }}</td>
                  </tr>
                }
                @if (device.tagNumber) {
                  <tr>
                    <td>
                      <strong>{{ t("device.tagNumber") }}</strong>
                    </td>
                    <td>{{ device.tagNumber }}</td>
                  </tr>
                }
                @if (device.type) {
                  <tr>
                    <td>
                      <strong>{{ t("device.type") }}</strong>
                    </td>
                    <td>{{ device.type }}</td>
                  </tr>
                }
                @if (device.importantNote) {
                  <tr class="important">
                    <td>
                      <strong>{{ t("device.importantNote") }}</strong>
                    </td>
                    <td>{{ device.importantNote }}</td>
                  </tr>
                }
              </table>
            </div>

            <!-- Service Info -->
            @for (service of device.services; track service) {
              <div class="xs12col s6col serviceStatus status{{service.status}}">
                <div class="status">
                  <span>{{convertServiceStatusEnum(service.status)}}</span>
                  <label class="identified">
                    <kendo-checkbox
                      type="checkbox"
                      kendoCheckBox
                      loadingIndication="/services/serviceIdentifiedChange"
                      [disabled]="revisionStatus?.isFinalStatus == true || !('Permissions.Services.Update' | permission)"
                      [checkedState]="service.identified == true"
                      (change)="onIdentifiedChange($event, service.id, device.id)">
                    </kendo-checkbox>
                    <span>{{ t("device.identified") }}</span>
                  </label>
                </div>
                @if (service.maintainerFirstName || service.maintainerLastName) {
                  <div class="footer">
                    <span>
                      <img src="../../../assets/icons/calendar-icon.svg"/>
                      <span>{{formatDeviceDate(service.dateExecuted)}}</span>
                    </span>
                    <span>
                      <img src="../../../assets/icons/profile-icon.svg"/>
                      <span>{{ service.maintainerFirstName }} {{ service.maintainerLastName }}</span>
                    </span>
                  </div>
                }
              </div>
              <div id="toggleContent-{{ index }}" [class.open]="serviceOpen[service.id]">
                @if (service?.description) {
                  <p class="deviceServiceDescription">
                    <strong>{{ t("serviceDesc") }}</strong><br />
                    {{ service.description }}
                  </p>
                }
                <!-- Service form -->
                <form [formGroup]="serviceForms[service.id]">
                  <!-- Basic service form -->
                  <div class="xs12col flexColumn">
                    <div class="padding-bottom-medium">
                      <kendo-label [text]="t('device.deviceWear')"></kendo-label>
                      <kendo-dropdownlist
                        [data]="deviceWearArray"
                        textField="text"
                        valueField="value"
                        formControlName="deviceWear"
                        [defaultItem]="{ value: null, text: t('chooseWear') }"
                        [valuePrimitive]="true"
                        [readonly]="revisionStatus?.isFinalStatus == true || !('Permissions.Services.Update' | permission)"
                        (valueChange)="onWearChange($event, service)">
                      </kendo-dropdownlist>
                    </div>
                    <div class="padding-bottom-medium">
                      <kendo-label [text]="t('device.devicePollution')"></kendo-label>
                      <kendo-dropdownlist
                        [data]="devicePollutionArray"
                        textField="text"
                        valueField="value"
                        formControlName="devicePollution"
                        [defaultItem]="{ value: null, text: t('choosePollution') }"
                        [valuePrimitive]="true"
                        [readonly]="revisionStatus?.isFinalStatus == true || !('Permissions.Services.Update' | permission)"
                        (valueChange)="onPollutionChange($event, service)">
                      </kendo-dropdownlist>
                    </div>
                  </div>
                  <div class="xs12col flexColumn padding-bottom-medium">
                    <kendo-label [text]="t('device.remark')"></kendo-label>
                    <kendo-textarea
                      formControlName="remark"
                      [rows]="3"
                      (blur)="revisionStatus?.isFinalStatus !== true ? saveRemark($event, service): null"
                      [readonly]="revisionStatus?.isFinalStatus == true || !('Permissions.Services.Update' | permission)">
                    </kendo-textarea>
                  </div>
                  @if (service.cancellationMessage) {
                    <div class="padding-bottom-medium">
                      <label class="k-label">{{ t('device.cancellationMessage') }}</label><br>
                      <span>{{ serviceForms[service.id].get('cancellationMessage')?.value }}</span>
                    </div>
                  }
                  <!-- service parts form -->
                  @if (getParts(service.id).controls.length > 0) {
                    <p class="xs12col fontBold">{{ t("availableParts") }}</p>
                    <div formArrayName="parts" class="wearingPartsContainer">
                      @for (partCtrl of getParts(service.id).controls; track partCtrl; let p = $index) {
                        <div [formGroupName]="p">
                          <div class="wearingPartContainer" [class.inactive-product]="partCtrl.value.productIsActive === false">
                            <div class="content xs12col">
                              <div class="flexColumn">
                                <span class="fontBold">{{t("wearingParts.name")}}</span>
                                <span>{{ partCtrl.value.productName }}</span>
                                @if (partCtrl.value.productIsActive === false && partCtrl.value.productInactiveReason) {
                                  <span class="tooltipContainer">
                                    <span [attr.tooltip]="partCtrl.value.productInactiveReason" flow="right" class="tooltipContainer">
                                      <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                                    </span>
                                  </span>
                                }
                              </div>
                              <div class="flexColumn">
                                <span class="fontBold">{{t("wearingParts.internalNumber")}}</span>
                                <span>{{partCtrl.value.productInternalNumber}}</span>
                              </div>
                              <div class="flexColumn">
                                <span class="fontBold">{{t("amount")}}</span>
                                <span>{{partCtrl.value.productQuantity}}</span>
                              </div>
                              <div class="flexColumn">
                                <span class="fontBold">{{t("amountUsedInService")}}</span>
                                <span>{{ partCtrl.value.amountUsed }}</span>
                              </div>
                              <div class="flexColumn">
                                <span class="fontBold">{{t("usedInService")}}</span>
                                <div class="checkboxContainer">
                                  <kendo-checkbox
                                    type="checkbox"
                                    kendoCheckBox
                                    loadingIndication="/ServiceParts/updateServicePart/"
                                    formControlName="isUsed"
                                    class="servicePartCheckbox"
                                    [class.disabled-checkbox]="revisionStatus?.isFinalStatus == true || (partCtrl.value.productIsActive === false && !partCtrl.value.isUsed)"
                                    (click)="(revisionStatus?.isFinalStatus || (partCtrl.value.productIsActive === false && !partCtrl.value.isUsed)) ? $event.preventDefault() : markServicePartDialogOpen(getParts(service.id), p, device.id)">
                                  </kendo-checkbox>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      <!-- Service part dialog -->
                      @if (markServicePartDialogOpened) {
                        <kendo-dialog
                          title="{{ t('markServicePart') }}"
                          (close)="markServicePartDialogClose($event, 'cancel')"
                          [minWidth]="250"
                          [width]="450">
                          <p style="margin: 30px; text-align: center">
                            {{ t("usedPartsMessage") }}
                          </p>
                          <div style="margin: 20px; text-align: center">
                            <input type="number" min="1" max="100000" [formControl]="currentAmountUsedControl" />
                          </div>
                          <kendo-dialog-actions>
                            <button
                              kendoButton
                              (click)="markServicePartDialogClose($event, 'cancel')">
                              {{ t("cancel") }}
                            </button>
                            <button
                              kendoButton
                              (click)="markServicePartDialogClose($event, 'confirm')"
                              themeColor="secondary">
                              {{ t("confirm") }}
                            </button>
                          </kendo-dialog-actions>
                        </kendo-dialog>
                      }
                    </div>
                  }
                  <!-- Service images -->
                  <div formArrayName="attachments" class="serviceImages">
                    @if (('Permissions.Revisions.Update' | permission) && revisionStatus?.isFinalStatus == false) {
                      <div class="titleAdd">
                        <p><strong>{{ t("device.uploadPictures") }}</strong></p>
                        <span [attr.tooltip]=" t('upload.service.tooltipPicture')"
                          flow="right"
                          class="tooltipContainer">
                          <img class="tooltipIcon" src="../assets/icons/information-icon.svg"/>
                        </span>
                      </div>
                    }
                    <kendo-upload
                      kendoButton
                      loadingIndication="/attachment/uploadAttachment"
                      (upload)="uploadServiceAttachment($event, service.id, device.id)"
                      [restrictions]="serviceRestrictions"
                      [ngClass]="{ uploading: vm.isUploading }"
                      [batch]="true"
                      class="padding-bottom-medium"
                      [hidden]="!('Permissions.Revisions.Update' | permission) || revisionStatus?.isFinalStatus == true">
                      <kendo-upload-messages
                        [dropFilesHere]="t('upload.service.dropZone')"
                        [select]=" vm.isUploading ? '&#x21bb;' : t('upload.service.button')">
                      </kendo-upload-messages>
                    </kendo-upload>
                    @if (getAttachments(service.id)) {
                      <div
                        class="serviceImageHeader xs12col flexRow"
                        media="(min-width: 993px)">
                        <span class="fontBold">{{ t("dataName") }}</span>
                        <span class="fontBold">{{ t("showInReport") }}</span>
                      </div>
                    }
                    <!-- DESKTOP -->
                    <div class="attachmentItems desktop">
                      @for (attachmentCtrl of getAttachments(service.id).controls; track attachmentCtrl; let a = $index) {
                        <div [formGroupName]="a"
                          class="attachmentItem">
                          <a
                            (click)="deleteAttachment(attachmentCtrl.value.id, service.id)"
                            loadingIndication="/revisions/deleteDeviceFromRevision/"
                            [hidden]="!('Permissions.Revisions.Update' | permission) || revisionStatus?.isFinalStatus == true"
                            class="deleteIconList">
                            <img src="../../../assets/icons/delete-icon.svg" />
                          </a>
                          <div class="thumbnailContainer">
                            <img class="thumbnail" [src]="attachmentCtrl.value.downloadedImage" />
                          </div>
                          <a (click)="downloadAttachment(attachmentCtrl.value)">{{ attachmentCtrl.value.fileName }}</a>
                          <div class="checkboxContainer">
                            <kendo-checkbox
                              type="checkbox"
                              kendoCheckBox
                              loadingIndication="/ServiceAttachments/updateServiceAttachment"
                              [disabled]="revisionStatus?.isFinalStatus == true"
                              [checkedState]="attachmentCtrl.value.showInReport"
                              (change)="onCheckboxChange($event, attachmentCtrl.value.id, device.id)">
                            </kendo-checkbox>
                          </div>
                        </div>
                      }
                    </div>
                    <!-- MOBILE -->
                    <div class="attachmentItems mobile">
                      @for (attachmentCtrl of getAttachments(service.id).controls; track attachmentCtrl; let a = $index) {
                        <div
                          [formGroupName]="a"
                          class="attachmentItem"
                          >
                          <a
                            (click)="deleteAttachment(attachmentCtrl.value.id, service.id)"
                            loadingIndication="/revisions/deleteDeviceFromRevision/"
                        [hidden]="
                          !(
                            'Permissions.Revisions.Update' | permission
                          ) || revisionStatus?.isFinalStatus == true
                        "
                            class="deleteIconList"
                            >
                            <img
                              src="../../../assets/icons/delete-icon.svg"
                              />
                            </a>
                            <div class="thumbnailContainer">
                              <img
                                class="thumbnail"
                                [src]="attachmentCtrl.value.downloadedImage"
                                />
                              </div>
                              <a
                                (click)="downloadAttachment(attachmentCtrl.value)"
                                >{{ attachmentCtrl.value.fileName }}</a
                                >
                                <span class="fontBold">{{
                                  t("showInReport")
                                }}</span>
                                <div class="checkboxContainer">
                                  <kendo-checkbox
                                    type="checkbox"
                                    kendoCheckBox
                                    loadingIndication="/ServiceAttachments/updateServiceAttachment"
                          [disabled]="
                            revisionStatus?.isFinalStatus == true
                          "
                                    [checkedState]="attachmentCtrl.value.showInReport"
                                    (change)="onCheckboxChange($event, attachmentCtrl.value.id, device.id)"
                                  ></kendo-checkbox>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                        <!-- dialogs -->
                        <!-- confirm service dialog -->
                        @if (completeServiceDialogOpened) {
                          <kendo-dialog
                            title="{{ t('confirmCompletion') }}"
                            (close)="completeServiceDialogClose('cancel')"
                            [minWidth]="250"
                            [width]="450">
                            <p style="margin: 30px; text-align: center">
                              {{ t("completeServiceMessage") }}
                            </p>
                            <div style="margin: 20px; text-align: center"></div>
                            <kendo-dialog-actions>
                              <button
                                kendoButton
                                (click)="completeServiceDialogClose('cancel')">
                                {{ t("cancel") }}
                              </button>
                              <button
                                kendoButton
                                (click)="completeServiceDialogClose('confirm')"
                                themeColor="secondary">
                                {{ t("completeService") }}
                              </button>
                            </kendo-dialog-actions>
                          </kendo-dialog>
                        }
                        <!-- cancel service dialog -->
                        @if (cancelServiceDialogOpened) {
                          <kendo-dialog
                            title="{{ t('confirmCancellation') }}"
                            (close)="cancelServiceDialogClose('cancel')"
                            [minWidth]="250"
                            [width]="450">
                            <p style="margin: 30px; text-align: center">
                              {{ t("cancelServiceMessage") }}
                            </p>
                            <div style="margin: 20px; text-align: center">
                              <textarea [(ngModel)]="cancelMessage" [ngModelOptions]="{standalone: true}" name="cancelMessage" rows="4">
                              </textarea>
                            </div>
                            <kendo-dialog-actions>
                              <button kendoButton (click)="cancelServiceDialogClose('cancel')">
                                {{ t("cancel") }}
                              </button>
                              <button
                                kendoButton
                                (click)="cancelServiceDialogClose('confirm')"
                                themeColor="primary"
                                >
                                {{ t("cancelService") }}
                              </button>
                            </kendo-dialog-actions>
                          </kendo-dialog>
                        }
                        <!-- actions -->
                        <div class="serviceActions">
                          <div class="flexRow" [hidden]="revisionStatus?.isFinalStatus == true">
                            <a loadingIndication="/services/serviceStatusChange"
                              [hidden]="!('Permissions.Services.Update' | permission) || service.status == 20 || revisionStatus == 20"
                              (click)="completeServiceDialogOpen(service.id, device.id)">
                              <img src="../../../assets/icons/check-icon.svg" class="buttonIcon"/>{{ t("finishService") }}
                            </a>
                            <a loadingIndication="/services/serviceStatusChange"
                              [hidden]="!('Permissions.Services.Update' | permission) || service.status == 30 || revisionStatus == 20"
                              (click)="cancelServiceDialogOpen(service.id, device.id)">
                              <img src="../../../assets/icons/close-circle-icon.svg" class="buttonIcon" />{{ t("cancelService") }}
                            </a>
                          </div>
                          <a [routerLink]="baseUrl + [device.id]"
                            [attr.tooltip]="t('open')"
                            flow="up"
                            class="actionIcon"
                            >
                            <img src="../../../assets/icons/open-link-icon.svg" />
                          </a>
                        </div>
                      </form>
                    </div>
                    <!-- delete icon -->
                    <button
                      kendoButton
                      (click)="deletionDialogOpen(device.id)"
                      [hidden]="!('Permissions.Revisions.RemoveDevice' | permission) || revisionStatus?.isFinalStatus == true || serviceForms[service.id].get('status')?.value != 10"
                      loadingIndication="revisions/deleteDeviceFromRevision/"
                      class="deleteIcon">
                      <img src="../../../assets/icons/close-icon.svg" />
                    </button>
                    <!-- delete device dialog -->
                    @if (deletionDialogOpened) {
                      <kendo-dialog
                        title="{{ t('confirmDeletion') }}"
                        (close)="deletionDialogClose('cancel')"
                        [minWidth]="250"
                        [width]="450">
                        <p style="margin: 30px; text-align: center">
                          {{ t("device.deletionMessage") }}
                        </p>
                        <kendo-dialog-actions>
                          <button kendoButton (click)="deletionDialogClose('cancel')">
                            {{ t("cancel") }}
                          </button>
                          <button
                            kendoButton
                            (click)="deletionDialogClose('delete')"
                            themeColor="primary"
                            >
                            {{ t("delete") }}
                          </button>
                        </kendo-dialog-actions>
                      </kendo-dialog>
                    }
                    <a (click)="toggle($event, index, service.id)"
                      class="toggleIcon xs12col justify-center"
                      [class.open]="serviceOpen[service.id]">
                      <img src="../../../assets/icons/arrow-icon.svg" />
                    </a>
                  }
                </div>
              }
            </div>
            <!-- Pagination controls -->
            <div class="pagination">
              <button
                (click)="previousPage()"
                [disabled]="!hasPreviousPage"
                class="pagination-btn">
                <kendo-svg-icon [icon]="caretAltLeftIcon"></kendo-svg-icon>
              </button>
              @for (page of getPageNumbers(); track page) {
                <button
                  (click)="goToPage(page)"
                  [class.active]="page === currentPage"
                  class="pagination-btn page-number">
                  {{ page }}
                </button>
              }
              <button
                (click)="nextPage()"
                [disabled]="!hasNextPage"
                class="pagination-btn">
                <kendo-svg-icon [icon]="caretAltRightIcon"></kendo-svg-icon>
              </button>
            </div>
            <!-- Page size selector -->
            <div class="page-size-selector">
              <div class="page-size-buttons">
                <button
                  type="button"
                  class="page-size-btn"
                  [class.active]="pageSize === 25"
                  (click)="onPageSizeChange(25)">
                  25
                </button>
                <button
                  type="button"
                  class="page-size-btn"
                  [class.active]="pageSize === 50"
                  (click)="onPageSizeChange(50)">
                  50
                </button>
                <button
                  type="button"
                  class="page-size-btn"
                  [class.active]="pageSize === 100"
                  (click)="onPageSizeChange(100)">
                  100
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      }